import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';

import { ErrorBoundary } from './utils/ErrorBoundary';
import Root from './root.component';
import CompanyRegulatoryInformationWithoutFlags from 'exported-components/CompanyRegulatoryInformation/CompanyRegulatoryInformation';
import KycWarningBannerWithoutFlags from 'exported-components/KycWarningBanner/KycWarningBanner';
import { FlagsProvider } from '@flash-tecnologia/feature-flags';
import {
  getAccessTokenPayloadSync,
  useSelectedCompany,
} from '@flash-tecnologia/hros-web-utility';

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: Root,
  errorBoundaryClass: ErrorBoundary,
});

export const { bootstrap, mount, unmount } = lifecycles;

export const CompanyRegulatoryInformation = () => {
  const { selectedCompany } = useSelectedCompany();
  const { economicGroupId, employeeId } = getAccessTokenPayloadSync();
  const APP_NAME = 'flash-hros-web-anti-fraud';

  return (
    <FlagsProvider
      url={process.env.UNLEASH_BENEFITS_URL || ''}
      appName={APP_NAME || ''}
      token={process.env.UNLEASH_BENEFITS_PROXY_KEY || ''}
      refreshIntervalSeconds={1800}
      initialContext={{
        userId: employeeId,
        properties: {
          economicGroupId,
          companyId: selectedCompany.id,
          employeeId,
        },
      }}
    >
      <CompanyRegulatoryInformationWithoutFlags />
    </FlagsProvider>
  );
};

export const KycWarningBanner = () => {
  const { selectedCompany } = useSelectedCompany();
  const { economicGroupId, employeeId } = getAccessTokenPayloadSync();
  const APP_NAME = 'flash-hros-web-anti-fraud';

  return (
    <FlagsProvider
      url={process.env.UNLEASH_BENEFITS_URL || ''}
      appName={APP_NAME || ''}
      token={process.env.UNLEASH_BENEFITS_PROXY_KEY || ''}
      refreshIntervalSeconds={1800}
      initialContext={{
        userId: employeeId,
        properties: {
          economicGroupId,
          companyId: selectedCompany.id,
          employeeId,
        },
      }}
    >
      <KycWarningBannerWithoutFlags />
    </FlagsProvider>
  );
};
